import React from 'react';
import Text from '../../../ui/Text';
import OnboardingList from './OnboardingList';
import * as Styles from './OnboardingStyles';

const Onboarding: React.FC = () => {
  return (
    <Styles.OnboardingContainer>
      <Styles.OnboardingLogin>
        <Styles.OnboardingTitle>
          Comece a dispensar
          <Styles.Highlight> Receitas Digitais </Styles.Highlight>
        </Styles.OnboardingTitle>
        <Text color="white" scale="body1">
          Cerca de 30 mil farmácias já dispensaram mais de <Styles.Highlight>3 MILHÕES</Styles.Highlight> de receitas
          digitais só em 2020.
        </Text>
        <OnboardingList />
      </Styles.OnboardingLogin>
    </Styles.OnboardingContainer>
  );
};

export default Onboarding;
